module.exports = __webpack_public_path__ + "mozambique.svg?4278b58a4b89fbfeeb73f87fc9b1905d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/mozambique.svg
// module id = 239
// module chunks = 10